import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex align-self-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomNumberField = _resolveComponent("CustomNumberField")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_color_picker = _resolveComponent("v-color-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_date_picker_wrapper = _resolveComponent("v-date-picker-wrapper")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pa-0 ma-0" }, {
    default: _withCtx(() => [
      (_ctx.properties)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            "no-gutters": ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredKeysAndOptions, (keyOpts, index) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  cols: _ctx.col,
                  class: "pb-3 px-1",
                  key: index
                }, {
                  default: _withCtx(() => [
                    (_ctx.getKeyType(keyOpts.options) === 'number')
                      ? (_openBlock(), _createBlock(_component_CustomNumberField, {
                          key: 0,
                          modelValue: _ctx.properties[keyOpts.key],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.properties[keyOpts.key]) = $event),
                          min: _ctx.getKeyValue(keyOpts.options, 'min'),
                          max: _ctx.getKeyValue(keyOpts.options, 'max'),
                          step: _ctx.getKeyValue(keyOpts.options, 'step'),
                          class: "",
                          density: "compact",
                          "hide-details": "",
                          label: _ctx.getKeyLabel(keyOpts.options),
                          disabled: !_ctx.isFieldEnabled(keyOpts.options)
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "max", "step", "label", "disabled"]))
                      : (_ctx.getKeyType(keyOpts.options) === 'select')
                        ? (_openBlock(), _createBlock(_component_v_select_filled, {
                            key: 1,
                            modelValue: _ctx.properties[keyOpts.key],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.properties[keyOpts.key]) = $event),
                            items: _ctx.getKeyChoices(keyOpts.options),
                            label: _ctx.getKeyLabel(keyOpts.options),
                            "hide-details": "auto",
                            multiple: !!keyOpts.options.multiple,
                            disabled: !_ctx.isFieldEnabled(keyOpts.options),
                            density: "compact",
                            "item-title": (item) => item.title ?? item.text ?? item
                          }, _createSlots({ _: 2 }, [
                            (!!keyOpts.options.multiple)
                              ? {
                                  name: "selection",
                                  fn: _withCtx(({ item, index }) => [
                                    (_ctx.properties[keyOpts.key] && _ctx.properties[keyOpts.key].length === 1)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.raw.text), 1))
                                      : _withDirectives((_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          class: "grey--text text-caption"
                                        }, _toDisplayString(_ctx.properties[keyOpts.key].length) + " sélections ", 513)), [
                                          [_vShow, index === 0]
                                        ]),
                                    _cache[2] || (_cache[2] = _createTextVNode(" gg "))
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1032, ["modelValue", "onUpdate:modelValue", "items", "label", "multiple", "disabled", "item-title"]))
                        : (_ctx.getKeyType(keyOpts.options) === 'boolean')
                          ? (_openBlock(), _createBlock(_component_v_checkbox, {
                              key: 2,
                              modelValue: _ctx.properties[keyOpts.key],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.properties[keyOpts.key]) = $event),
                              color: "primary",
                              label: _ctx.getKeyLabel(keyOpts.options),
                              density: "compact",
                              "hide-details": "auto",
                              disabled: !_ctx.isFieldEnabled(keyOpts.options)
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disabled"]))
                          : (
                        _ctx.getKeyType(keyOpts.options) === 'color' ||
                        _ctx.getKeyType(keyOpts.options) === 'colour'
                    )
                            ? (_openBlock(), _createBlock(_component_v_menu, {
                                key: 3,
                                "offset-y": "",
                                "close-on-content-click": false,
                                "onUpdate:modelValue": _ctx.colorMenuInput
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field_filled, _mergeProps({
                                            modelValue: _ctx.properties[keyOpts.key],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.properties[keyOpts.key]) = $event),
                                            ref_for: true
                                          }, props, {
                                            label: _ctx.getKeyLabel(keyOpts.options),
                                            readonly: "",
                                            "hide-details": "",
                                            density: "compact"
                                          }), {
                                            "prepend-inner": _withCtx(() => [
                                              _createElementVNode("div", {
                                                class: "d-flex align-self-center",
                                                style: _normalizeStyle(_ctx.colorIconStyle(_ctx.properties[keyOpts.key]))
                                              }, null, 4)
                                            ]),
                                            _: 2
                                          }, 1040, ["modelValue", "onUpdate:modelValue", "label"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                default: _withCtx(() => [
                                  true
                                    ? (_openBlock(), _createBlock(_component_v_color_picker, {
                                        key: 0,
                                        modelValue: _ctx.properties[keyOpts.key],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.properties[keyOpts.key]) = $event),
                                        "show-swatches": "",
                                        mode: "hexa",
                                        "hide-details": "auto",
                                        "hide-mode-switch": "",
                                        swatches: _ctx.swatches,
                                        disabled: !_ctx.isFieldEnabled(keyOpts.options)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "swatches", "disabled"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["onUpdate:modelValue"]))
                            : (_ctx.getKeyType(keyOpts.options) === 'date-picker')
                              ? (_openBlock(), _createBlock(_component_v_menu, {
                                  key: 4,
                                  modelValue: _ctx.isDatePickerOpen,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isDatePickerOpen) = $event)),
                                  "offset-y": "",
                                  "close-on-content-click": false
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_text_field_filled, _mergeProps({
                                              "model-value": _ctx.dateRangeToString(_ctx.properties[keyOpts.key]),
                                              ref_for: true
                                            }, props, {
                                              label: _ctx.getKeyLabel(keyOpts.options),
                                              readonly: "",
                                              "hide-details": "",
                                              disabled: !_ctx.isFieldEnabled(keyOpts.options),
                                              density: "compact"
                                            }), {
                                              "prepend-inner": _withCtx(() => [
                                                _createElementVNode("div", _hoisted_2, [
                                                  _createVNode(_component_v_icon, { size: "x-small" }, {
                                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                      _createTextVNode("$fa-calendar-alt")
                                                    ])),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _: 2
                                            }, 1040, ["model-value", "label", "disabled"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_date_picker_wrapper, {
                                      modelValue: _ctx.properties[keyOpts.key],
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.properties[keyOpts.key]) = $event),
                                      color: "gradient",
                                      "first-day-of-week": "1",
                                      type: _ctx.getKeyValue(keyOpts.options, 'unit'),
                                      min: _ctx.getKeyValue(keyOpts.options, 'min'),
                                      max: _ctx.getKeyValue(keyOpts.options, 'max'),
                                      multiple: "range",
                                      style: {"max-width":"400px"},
                                      scrollable: "",
                                      "full-width": "",
                                      "no-title": "",
                                      landscape: !_ctx.$vuetify.display.xs,
                                      disabled: !_ctx.isFieldEnabled(keyOpts.options)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "type", "min", "max", "landscape", "disabled"]),
                                    _createVNode(_component_v_btn_primary, {
                                      density: "default",
                                      elevation: "0",
                                      rounded: "xl",
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDatePickerOpen = false)),
                                      size: "small",
                                      class: "mt-2"
                                    }, {
                                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                                        _createTextVNode(" Valider ")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue"]))
                              : (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                  key: 5,
                                  modelValue: _ctx.properties[keyOpts.key],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.properties[keyOpts.key]) = $event),
                                  outlined: "",
                                  "hide-details": "auto",
                                  class: "",
                                  label: _ctx.getKeyLabel(keyOpts.options),
                                  disabled: !_ctx.isFieldEnabled(keyOpts.options),
                                  density: "compact"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disabled"]))
                  ]),
                  _: 2
                }, 1032, ["cols"]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}